import Reveal from "./Reveal";
import { Plane, MapPinned, Cpu, Server, Rocket, Briefcase, Landmark, ScrollText } from "lucide-react";

const sectors = [
  { icon: Plane, label: "Travel" },
  { icon: MapPinned, label: "Tourism" },
  { icon: Cpu, label: "Technology" },
  { icon: Server, label: "IT" },
  { icon: Rocket, label: "Startups" },
  { icon: Briefcase, label: "Business" },
  { icon: Landmark, label: "Public Policy" },
  { icon: ScrollText, label: "Governance" },
];

const Sectors = () => {
  return (
    <section id="sectors" data-testid="sectors-section" className="py-20 sm:py-28 bg-[#FAFAFA] bg-grid-navy">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal>
          <div className="max-w-2xl">
            <p className="text-xs uppercase tracking-widest text-[#D91C29] font-semibold">Where we work</p>
            <h2 className="font-serif-display text-3xl sm:text-4xl font-bold text-[#0B1B3D] tracking-tight mt-3">
              Sectors we serve
            </h2>
            <p className="mt-4 text-slate-600 leading-relaxed">
              Deep, cross-sector experience lets us translate complex agendas into
              campaigns and events that resonate with the right stakeholders.
            </p>
          </div>
        </Reveal>

        <div className="mt-12 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5">
          {sectors.map((s, i) => {
            const Icon = s.icon;
            return (
              <Reveal key={s.label} delay={i * 0.06}>
                <div
                  data-testid={`sector-${i}`}
                  className="group flex items-center gap-4 rounded-xl border border-slate-200 bg-white px-5 py-5 hover:border-[#D91C29] hover:-translate-y-1 transition-transform transition-colors duration-300"
                >
                  <div className="w-11 h-11 rounded-lg bg-[#0B1B3D] flex items-center justify-center shrink-0 group-hover:bg-[#D91C29] transition-colors duration-300">
                    <Icon size={20} className="text-white" />
                  </div>
                  <span className="font-semibold text-[#0B1B3D]">{s.label}</span>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Sectors;
